import React, { useMemo } from 'react';

import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import { createLaunchDarklyContext } from '@adsk/alloy-provider';

const LD_API_KEYS = {
  [ENVS.QA]: '5cfe5a82648b9507525dcb0e',
  [ENVS.STAGING]: '5d12565bd7bc9707683c5682',
  [ENVS.PRODUCTION]: '5cfe5a817682e907558f568c',
};

const {
  LaunchDarklyProvider,
  useFeatureFlag: usePlangridFeatureFlag,
  useAllFeatureFlags: usePlangridAllFeatureFlags,
} = createLaunchDarklyContext();

const PlangridLaunchDarklyProvider = (props) => {
  const env = getEnv();
  const apiKey = useMemo(() => LD_API_KEYS[env], [env]);
  return <LaunchDarklyProvider apiKey={apiKey} {...props} />;
};

export {
  usePlangridFeatureFlag,
  usePlangridAllFeatureFlags,
  PlangridLaunchDarklyProvider,
};
